import {call,put ,all,fork ,takeEvery} from 'redux-saga/effects';
import {device} from '../../helpers/api/services/Clairco/device';
import { DeviceActionTypes } from './constants';
import { deviceApiResponseSuccess,deviceApiResponseError } from './actions';
import { SagaIterator } from 'redux-saga';
import { iaq } from '../../helpers/api/services/Clairco/Iaq';


function* getDevices():SagaIterator{
    try {
        const response = yield call(device.all);
        const devices = response?.data;
        yield put(deviceApiResponseSuccess(DeviceActionTypes.GET_DEVICES,devices));
    } catch (error) {
        yield put(deviceApiResponseError(DeviceActionTypes.GET_DEVICES,error));
    }
}

function* getDeviceTypes():SagaIterator{
    try {
        const response = yield call(device.types);
        const deviceTypes = response?.data;
        yield put(deviceApiResponseSuccess(DeviceActionTypes.GET_DEVICE_TYPES,deviceTypes));
    } catch (error) {
        yield put(deviceApiResponseError(DeviceActionTypes.GET_DEVICE_TYPES,error));
    }
}

function* calibration(action: any): SagaIterator {

    try {
        const { data } = action.payload; 

        const response = yield call(iaq.calibration, {
            body: {
                parameter: data.parameter,
                calib: data.calib,
            },
            params: {
                deviceType: data.deviceType,
                id: data.id,
                
            },
        });


        if (action.payload.onSuccess) {
            console.log("API response data:", response.data);
            action.payload.onSuccess(response.data);
        }

    } catch (error) {
        console.log("API Error:", error);

        if (action.payload.onError) {
            console.log("Calling error callback");
            action.payload.onError(error);
        }
    }
}

function* watchGetDevices(){
    yield takeEvery(DeviceActionTypes.GET_DEVICES,getDevices)
}

function* watchGetDeviceTypes(){
    yield takeEvery(DeviceActionTypes.GET_DEVICE_TYPES,getDeviceTypes)

}
function* watchCalibration() {
    yield takeEvery(DeviceActionTypes.CALIBRATION, calibration);
}

function* deviceSage(){
    yield all([
        fork(watchGetDevices),
        fork(watchGetDeviceTypes),
        fork(watchCalibration),
    ]);
}



export default deviceSage;